export const SvgMinus: string = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20width%3D"18.13"%20height%3D"3"%3E%3Cpath%20fill%3D"none"%20stroke%3D"%23fff"%20stroke-linecap%3D"round"%20stroke-width%3D"3"%20d%3D"M1.5%201.5h15.13"%2F%3E%3C%2Fsvg%3E';
export default SvgMinus;
